export const MENU = {
  SET_POPUP: 'SET_POPUP',
  TOGGLE_POPUP: 'TOGGLE_POPUP',
  REMOVE_POPUP: 'REMOVE_POPUP',
}
